export const GET_HIGHLIGHTS = 'GET_HIGHLIGHTS'
export const GET_SUBURBS = 'GET_SUBURBS'
export const GET_POSTAL_CODES = 'GET_POSTAL_CODES'
export const GET_PRICING_PACKAGES = 'GET_PRICING_PACKAGES'